import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import useGetAllBanksLight from "../../../customHooks/GET_requests/useGetAllBanksLight";
// COMPONENTS
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACE
import { BankLightInterface } from "../../../interfaces/Bank.interface";

export default function SelectBanks({
  inputValue,
  inputOnChange,
  disabledInput,
}: {
  inputValue: string;
  inputOnChange: (id: string, name: string) => void;
  disabledInput: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const {
    banksLight,
    isLoadingGetAllBanksLight,
    errorMessageGetAllBanksLight,
    isErrorGetAllBanksLight,
  } = useGetAllBanksLight();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChange = (newValue: string) => {
    const index = banksLight.findIndex((item: any) => String(item.id ?? "") === newValue);
    if (index >= 0) {
      inputOnChange(String(banksLight[index].id ?? ""), String(banksLight[index].name ?? ""));
    }
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className=" generalStyles__width100">
      <Select
        loading={isLoadingGetAllBanksLight}
        size="middle"
        className="generalStyles__width100"
        value={inputValue}
        placeholder={t("general.bank")}
        onChange={onChange}
        showSearch
        optionFilterProp="label" // Ensures Ant Design uses `label` for searching
        filterOption={(input, option) =>
          typeof option?.label === "string" &&
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        disabled={disabledInput}
      >
        {banksLight.map((item: BankLightInterface) => (
          <Option
            key={String(item.id ?? "")}
            value={String(item.id ?? "")}
            label={String(item.name ?? "")}
          >
            <span className="generalStyles__info">
              {item && item.channel && item.channel.server && item.channel.server.name
                ? String(item.channel.server.name ?? "")
                : ""}
            </span>
            : {String(item.name ?? "")}
          </Option>
        ))}
      </Select>
      <GlobalAlert2
        isError={isErrorGetAllBanksLight}
        isSuccess={false}
        requestType="GET"
        error={errorMessageGetAllBanksLight}
        name="Banks"
      />
    </div>
  );
}
